module.exports = __webpack_public_path__ + "img/BOTELLATECATE0.0.377b574a.png";